import { useEffect, useRef } from 'react'
import { router } from '@inertiajs/react'
import consumer from '@/channels/consumer'

export function useSessionListChannel() {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    const subscription = consumer.subscriptions.create(
      { channel: 'Monitoring::SessionListChannel' },
      {
        received() {
          // Debounce: coalesce rapid updates into a single reload
          if (timerRef.current) clearTimeout(timerRef.current)
          timerRef.current = setTimeout(() => {
            router.reload({ only: ['session_logs'] })
          }, 500)
        },
      }
    )

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
      subscription.unsubscribe()
    }
  }, [])
}
